"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
const observer_1 = __importDefault(require("./observer"));
__exportStar(require("./types"), exports);
__exportStar(require("./event"), exports);
class EventBus {
    constructor() {
        this.observers = {};
        this.lastPublishedEvents = {};
    }
    publish(type, event) {
        const observer = this.observers[type];
        if (observer) {
            observer.publish(event);
        }
        this.lastPublishedEvents[type] = event;
    }
    subscribe(type, listener, receiveLastPublished = false) {
        const observer = this.observers[type];
        if (!observer) {
            this.observers[type] = new observer_1.default();
        }
        const unsubscriber = this.observers[type].subscribe(listener);
        if (receiveLastPublished && this.lastPublishedEvents[type]) {
            listener(this.lastPublishedEvents[type]);
        }
        return () => {
            unsubscriber();
        };
    }
}
exports.EventBus = EventBus;
//# sourceMappingURL=index.js.map